import { CircleX } from 'lucide-react';
import type { FailedStepProps } from '../types';
import { BackToLoginLink, InfoBox, InfoBoxTitle, InfoBoxList } from '../shared';

/**
 * 验证失败步骤页面
 */
export function VerifyFailedStep({ onStepChange }: FailedStepProps) {
  const reasons = [
    "You haven't clicked the latest verification link yet",
    'The verification link has expired (valid for 1h)',
    'Network issues',
  ];

  return (
    <div className="flex w-full flex-col gap-[20px]">
      {/* 标题区域 */}
      <div className="flex flex-col items-center gap-[8px]">
        <div className="flex items-center gap-[8px]">
          <CircleX className="h-[28px] w-[28px] text-[#ef4444]" />
          <h2 className="text-[24px] font-semibold leading-[1.2] tracking-[-0.48px] text-[#ef4444]">
            Verification failed
          </h2>
        </div>
        <p className="text-center text-[14px] font-normal leading-[1.5] tracking-[0.07px] text-[#525252]">
          Sorry, we were unable to verify your account.
        </p>
      </div>

      {/* 可能原因 */}
      <InfoBox>
        <InfoBoxTitle>Possible reasons:</InfoBoxTitle>
        <InfoBoxList items={reasons} />
      </InfoBox>

      {/* 返回登录按钮 */}
      <BackToLoginLink variant="icon" onClick={() => onStepChange?.('login')} />
    </div>
  );
}

export default VerifyFailedStep;
